







































import Vue from 'vue'
import DataTableToolbar from '@/components/Global/DataTableToolbar.vue'
import UserActions from '@/components/Users/UserActions.vue'
import EditUserDrawer from '@/components/Users/EditUserDrawer.vue'
import AddUserDrawer from '@/components/Users/AddUserDrawer.vue'

import { headers } from '@/components/Users/constants'
import { mutations, portalState } from '@/state'
import {
  apiDropdownsBusinesses,
  apiDropdownsRoles,
  apiGetUsersPaginated, apiHardDeleteUser,
  apiRestoreUser,
  apiSoftDeleteUser
} from '@/api'
import { gsap } from 'gsap'

type User = { name: string; id: string }

export default Vue.extend({
  name: 'Users',
  components: {
    DataTableToolbar,
    UserActions,
    EditUserDrawer,
    AddUserDrawer
  },
  computed: {
    tableHeaders () { return headers(this.t) },
    loggedInUserObject () { return portalState.user }
  },
  data () {
    return {
      users: [],
      businesses: [],
      roles: [],
      loading: true,
      search: '',
      timeout: null,
      options: {},
      controller: null,
      userToBeEdited: {},
      footerProps: { itemsPerPageOptions: [10, 25, 50] },
      queryParams: { direction: 'desc' },
      totalServerItems: 0,
      clickedUser: null,
      addUserDrawerOpened: false,
      editUserDrawerOpened: false
    }
  },
  methods: {
    initialize () {
      if (this.controller) this.controller.abort()
      this.controller = new AbortController()
      this.loading = true
      this.users = []
      const { sortDesc, page, itemsPerPage } = this.options
      this.queryParams.direction = sortDesc[0] ? 'asc' : 'desc'
      const searchParam = this.search !== '' && typeof this.search === 'string' ? `&search=${this.search.toLowerCase()}` : ''
      const paginationConfig = {
        page, limit: itemsPerPage, direction: this.queryParams.direction, search: searchParam, signal: this.controller.signal
      }
      apiGetUsersPaginated(paginationConfig)
        .then((res: any) => {
          const formattedUsers = res.data.data.map((user: any) => {
            return {
              ...user,
              last_seen_at: this.dateTimeToLocal(user.last_seen_at),
              name: `${user.first_name} ${user.last_name}` }})
          this.users = formattedUsers
          this.totalServerItems = res.data.pagination.total
          if (res.data.pagination.total_pages < page) this.options.page = 1
          this.loading = false
        }).catch(e => {
          mutations.setSnackbar('error', e.response.data.message)
        }).finally(() => this.gsapFadeIn())
    },
    async getBusinesses () {
      apiDropdownsBusinesses().then((res: any) => {
        this.businesses = res.data.data
      }).catch((e: any) => mutations.setSnackbar('error', e.response.data.message))
    },
    getRoles () {
      apiDropdownsRoles().then((res: any) => {
        this.roles = res.data.data
      }).catch((e: any) => mutations.setSnackbar('error', e.response.data.message))
    },
    clickEvent (e: { event: string; user: User }) {
      switch (e.event) {
        case 'editUser':
          this.editUser(e.user)
          break
        case 'deleteUser':
          this.deleteUser(e.user)
          break
        case 'restoreUser':
          this.restoreUser(e.user)
          break
        case 'hardDeleteUser':
          this.hardDeleteUser(e.user)
          break
      }
    },
    editUser (user: User) {
      this.editUserDrawerOpened = true
      this.userToBeEdited = user
    },
    async deleteUser (user: User) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmText', component: 'messages' }, [user.name]))
      if (!isConfirmed) return
      try {
        mutations.setSnackbar()
        await apiSoftDeleteUser(user.id)
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      }
      this.initialize()
    },
    async restoreUser (user: User) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmTextRestore', component: 'messages' }, [user.name]))
      if (!isConfirmed) return
      try {
        mutations.setSnackbar()
        await apiRestoreUser(user.id)
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
      } catch (e: any) {
        mutations.setSnackbar('error', e.response.data.message)
      }
      this.initialize()
    },
    async hardDeleteUser (user: User) {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmTextHardDelete', component: 'messages' }, [user.name]))
      if (!isConfirmed) return
      mutations.setSnackbar()
      await apiHardDeleteUser(user.id)
        .then(() => {
          mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar'}))
          this.initialize()
        }).catch((e: any) => mutations.setSnackbar('error', e.response.data.message))
    },
    checkIfTrashed (item: {trashed: boolean}) {
      if (!item.trashed) return 'fade-in'
      if (this.$vuetify.theme.dark) return 'trashed-item-dark fade-in'
      return 'trashed-item fade-in'
    },
    updateSearch (val: string) { this.search = val }
  },
  mounted () {
    this.getBusinesses()
    this.getRoles()
  },
  watch: {
    options: {
      handler () {
        this.initialize()
      },
      deep: true
    },
    search () {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.initialize()
      }, 500)
    }
  }
})
